import Button from '@sats-group/ui-lib/react/button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { Dialog } from '~/source/ui/dialog/dialog';
import { Legend } from './legend';
import type { LineGraph as Props } from './line-graph.types';

export const LineGraph: React.FC<Props> = ({ data, illustration }) => (
  <figure className="line-graph">
    <div className="line-graph__figure" role="img">
      <div className="line-graph__x">
        <Text size={Text.sizes.interface}>{illustration.xMax}</Text>
        <Text size={Text.sizes.interface}>{illustration.xMin}</Text>
      </div>
      <div className="line-graph__y">
        <Text size={Text.sizes.interface}>{illustration.yMax}</Text>
        <Text size={Text.sizes.interface}>{illustration.yMin}</Text>
      </div>
      <div className="line-graph__illustration">
        <svg {...illustration.vector.props}>
          <polyline
            {...illustration.vector.line}
            fill="none"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
    <div>
      <Legend {...illustration.legend} />
    </div>
    <div className="line-graph__actions">
      <Button
        popoverTarget={data.dialog.props.id}
        popoverTargetAction="show"
        size={Button.sizes.small}
        text={data.dialog.trigger}
        variant={Button.variants.secondary}
      />
    </div>
    <Dialog {...data.dialog.props}>
      <figcaption>
        <table className="line-graph__data">
          <thead>
            <tr>
              <th>
                <Text size={Text.sizes.interface}>{data.x}</Text>
              </th>
              <th>
                <Text size={Text.sizes.interface}>{data.y}</Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.entries.map(([name, value]) => (
              <tr key={name}>
                <td>
                  <Text size={Text.sizes.interface}>{name}</Text>
                </td>
                <td>
                  <Text size={Text.sizes.interface}>{value}</Text>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </figcaption>
    </Dialog>
  </figure>
);
